// Optional polyfills to support WebGL1
// Normally not imported directly
// The files in this directory should be self contained and not include any other files
export { default as polyfillContext } from './polyfill-context';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/luma.gl/dist/esm/webgl1/index.js
// module id = 596
// module chunks = 0